import React from 'react';
import { motion } from 'framer-motion';
import { GameLoopVisualization } from './GameLoopVisualization';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-gradient-to-b from-midnight-deep to-midnight-light" aria-label="Hero section" data-id="element-57">
      {/* Subtle background grid */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'linear-gradient(rgba(245,166,35,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(245,166,35,0.3) 1px, transparent 1px)',
      backgroundSize: '80px 80px'
    }} data-id="element-58" />

      {/* Radial ambient light */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-amber/[0.03] blur-[120px]" data-id="element-59" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-0" data-id="element-60">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-61">
          {/* Text content */}
          <div className="flex-1 text-center lg:text-left max-w-2xl" data-id="element-62">
            <motion.p className="font-sora text-amber text-sm font-semibold tracking-[0.2em] uppercase mb-6" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-63">
              AI-Powered Game Loop Intelligence
            </motion.p>

            <motion.h1 className="font-sora text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-[1.08] mb-6" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.3,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-64">
              Every Great Game Has a{' '}
              <span className="text-amber" data-id="element-65">Hidden Engine</span>
            </motion.h1>

            <motion.p className="font-inter text-lg lg:text-xl text-text-secondary leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-66">
              Keystonegames uses AI to decode, simulate, and perfect the core
              loops that drive player engagement in iGaming.
            </motion.p>

            <motion.div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.9,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-67">
              <a href="#solution" className="inline-flex items-center justify-center px-8 py-4 bg-amber hover:bg-amber-hover text-midnight-deep font-inter font-semibold text-base rounded-lg transition-all duration-300 hover:shadow-[0_0_30px_rgba(245,166,35,0.3)]" data-id="element-68">
                See How It Works
              </a>
              <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 border border-white/20 hover:border-white/40 text-white font-inter font-semibold text-base rounded-lg transition-all duration-300 hover:bg-white/5" data-id="element-69">
                Talk to Us
              </a>
            </motion.div>
          </div>

          {/* Visualization */}
          <motion.div className="flex-1 flex justify-center lg:justify-end" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1.5,
          delay: 0.4
        }} data-id="element-70">
            <GameLoopVisualization data-id="element-71" />
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} data-id="element-72">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-73">
          <ChevronDownIcon className="w-6 h-6 text-text-muted" aria-hidden="true" data-id="element-74" />
        </motion.div>
      </motion.div>
    </section>;
}